import React from 'react';
import { css } from '@emotion/css/macro';
import Color from '../../../common/Color';
import IconClose from '../../../icons/IconClose';

export default function PrivacyView({ onClickClose }) {
  const wrapper = css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${Color.WHITE};
  `;

  const topWrapper = css`
    border-bottom: solid 1px #cacede;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 22px 21px 19px;
    button {
      background-color: rgba(0, 0, 0, 0);
    }
  `;

  const title = css`
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    letter-spacing: -0.72px;
  `;

  const bodyWrapper = css`
    background-color: ${Color.WHITE};
    padding: 15px 21px 12px;
  `;
  return (
    <div className={wrapper}>
      <div className={topWrapper}>
        <div className={title}>도그메이트 개인정보 취급방침</div>
        <button onClick={onClickClose ? onClickClose : () => window.history.back()}>
          <IconClose strokeColor={Color.MEDIUM_GRAY} size='14' />
        </button>
      </div>
      <div className={bodyWrapper}>
        <>
          <P>
            주식회사 도그메이트(이하 “회사”라 한다.)는 회원님들의 개인정보를 안전하게 보호하기 위하여 최선의 노력을
            다하고 있으며, 개인정보보호관련 법규 및 정부기관의 가이드라인을 준수하고 있습니다. 회사는 개인정보
            취급방침을 통하여 회원님의 개인정보가 어떻게 이용되고 있고, 이용 시 어떠한 보호조치가 취해지고 있는지
            알려드립니다. 개인정보 취급방침은 법령의 변경이나, 보다 나은 서비스의 제공을 위하여 내용이 변경될 수
            있습니다. 개인정보 취급방침은 홈페이지 첫 화면의 맨 아래에 굵은 글씨로 표시되어 있습니다. 개인정보
            취급방침과 이용 약관의 개인정보 관련한 내용의 경우 이용약관이 우선 순위를 갖습니다.
          </P>
        </>
        <>
          <OlDecimal>
            <>
              <Li>개인정보 수집에 대한 동의</Li>
              <P>
                회사는 서비스 이용을 위한 회원가입 시 이용약관의 내용에 대하여 동의하는 의사표시를 ‘서비스
                이용약관’,‘개인정보취급방침’, ‘안전보상제도 약관’과 ‘가입하기’ 버튼을 누르는 절차를 마련하고 있으며 같은
                화면에서 개인정보취급방침 또한 확인하실 수 있습니다. 동의의 의사표시가 있는 경우 개인정보의 수집에
                동의한 것으로 봅니다. 또한 회사는 개인정보취급방침을 홈페이지 첫 화면에 공개함으로써 귀하께서 언제나
                용이하게 보실 수 있도록 조치하고 있습니다.
              </P>
            </>
            <>
              <Li>개인정보 수집 및 이용 목적</Li>
              <P>
                1) 회사가 개인정보를 수집하는 목적은 회원의 신분과 서비스 이용의사를 확인하여 최적화되고 맞춤화된
                서비스를 제공하기 위함입니다. 회사는 회원께서 서비스 상품을 주문, 결제하고 기타 회원님들을 위한 각종
                서비스를 제공하기 위해 필요한 최소한의 정보를 수집하고 있습니다.
              </P>
              <P>
                2) 회사는 개인정보의 기본 수집 목적 이외에 다른 용도로 이를 이용하거나 회원의 동의 없이 제3자에게 이를
                제공하지 않습니다.
              </P>
              <P>
                3) 회사는 회원의 인권을 침해할 우려가 있는 민감한 정보(인종, 사상 및 신조, 정치적 성향이나 범죄기록,
                의료정보 등)는 어떠한 경우에도 수집하지 않으며, 만약 불가피하게 수집하는 경우에는 반드시 회원에게 사전
                동의를 구합니다.
              </P>
              <P>
                4) 회사는 이벤트 및 프로모션 진행 시 희망자에 한해 광고성 정보를 전송하기 위해 수신자의 사전 수신 동의를
                받고 있으며, 회원이 정보 삭제 또는 이용 정지 요청을 및 회원탈퇴 시 즉시 삭제합니다.(이벤트 및 도그메이트
                홈페이지의 회원정보 혹은 도그메이트APP의 앱설정에서 철회 가능합니다.)
              </P>
              <P>5) 회사는 회원의 개인정보를 다음과 같이 수집합니다.</P>
              <P2>가) 회원 가입 시</P2>
              <P3>이메일, 비밀번호, 이름, 주소, 성별, CI, DI, 생년월일, 가입인증 휴대폰번호, 이통사 정보</P3>
              <P2>나) 서비스 구매 시</P2>
              <P3>
                반려동물 정보, 신분인증 사진(신분증, 우편물), 결제를 위한 신용카드 정보, 은행계좌 정보, 주거관련 정보,
                결제기록 등의 정보
              </P3>
              <P2>다) 펫시터 등록 시</P2>
              <P3>
                신분인증 사진, 펫시터로 활동하기 위한 주거형태 및 가족구성원, 반려동물 키운 경험에 관한 정보, 관련
                이미지
              </P3>
              <P2>라) 펫시터 수익금 출금 신청 시</P2>
              <P3>수익금 출금과 수익금에 관해 세금 신고를 위한 실명확인 정보(이름 및 주민등록번호)</P3>
              <P2>마) 앱 이용 시</P2>
              <P3>PUSH 토큰</P3>
              <P2>바) 기타</P2>
              <P3>
                서비스 이용과정에서 자동 수집 정보 : IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록, 기기
                정보, 단말식별번호 (단말기 아이디)
              </P3>
              <P2>사) 이벤트 및 마케팅 정보 수신 동의 시 (선택적 항목)</P2>
              <P3>
                회원이 제공받은 쿠폰의 유효기간 혹은 쿠폰 소멸 정보와 관련한 정보 수신할 연락처 정보 (휴대폰번호,
                이메일)
              </P3>
              <P>6) 수집한 개인정보는 다음과 같은 목적으로 사용됩니다.</P>
              <P2>가) 개인 식별 : 이메일, 휴대폰번호, CI, 이름, 비밀번호, 주소</P2>
              <P2>나) 본인 인증 : 이름, 휴대폰 번호, 이통사 정보, 생년월일, 성별</P2>
              <P2>
                다) 서비스 구매 및 요금 결제, 환불, 관련 법령에 의한 기록 보존 : 신용카드 정보, 은행계좌 정보, 결제기록
                등의 정보, 이름, 주소, 이메일 등 거래주체 식별 정보
              </P2>
              <P2>
                라) 서비스 제공을 위한 연락 및 안내, 민원 처리 : 이름, 이메일, 휴대폰 번호, 주소, 생년월일, 성별 등
              </P2>
              <P2>마) 세금 신고 : 이름, 주민등록번호</P2>
              <P2>바) 이벤트 및 신규 서비스 안내, 마케팅 및 광고 : 이름, 이메일, 휴대폰번호, PUSH 토큰</P2>
              <P>7) 회사는 회원가입, 요금결제, 서비스 문의 게시판, 고객 상담 등을 통하여 개인정보를 수집합니다.</P>
            </>
            <>
              <Li>개인정보의 보유 및 이용기간</Li>
              <P>
                회사는 원칙적으로 개인정보 이용목적 달성 후에는 해당 개인정보를 지체 없이 파기합니다. 단, 내부방침 및
                관계법령의 규정에 의하여 보존할 필요가 있는 경우 아래와 같이 관계법령에서 정한 일정한 기간 동안
                회원정보를 보관합니다.
              </P>
              <P>1) 내부 방침(부정이용기록)</P>
              <P2>가) 보존이유 : 기존 구매 서비스에 대한 본인 인증 필요성(부정이용의 배제 등 회사 방침에 의한 보존)</P2>
              <P2>나) 보존항목 : 이름, 휴대폰 번호, 이메일, 주소</P2>
              <P2>다) 보존기간 : 계약기간 내내, 계약해지 후 2 년</P2>
              <P>2) 상법 등 법령에 따라 보존할 필요성이 있는 경우</P>
              <P2>가) 계약 또는 청약철회 등에 관한 기록</P2>
              <P3>a) 2보존근거 : 전자상거래 등에서의 소비자보호에 관한 법률</P3>
              <P3>b) 보존기간 : 5년</P3>
              <P2>나) 대금결제 및 서비스 등의 공급에 관한 기록</P2>
              <P3>a) 보존근거 : 전자상거래 등에서의 소비자보호에 관한 법률</P3>
              <P3>b) 보존기간 : 5년</P3>
              <P2>다) 소비자의 불만 또는 분쟁처리에 관한 기록</P2>
              <P3>a) 보존근거 : 전자상거래 등에서의 소비자보호에 관한 법률</P3>
              <P3>b) 보존기간 : 3년</P3>
              <P2>라) 웹사이트 방문기록</P2>
              <P3>a) 보존근거 : 통신비밀보호법</P3>
              <P3>b) 보존기간 : 3개월</P3>
            </>
            <>
              <Li>개인정보의 파기절차 및 방법</Li>
              <P>회원의 개인정보는 원칙적으로 개인정보의 이용목적이 달성될 경우 지체 없이 파기됩니다.</P>
              <P>단, 일정기간 동안 회사를 이용하지 아니할 경우 회원님에게 이를 고지하고 별도 DB에 보관합니다.</P>
              <P>1) 파기절차</P>
              <P2>
                가) 회원의 개인정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 사유에
                따라(보유 및 이용기간 참조) 일정 기간 보관된 후 파기됩니다.
              </P2>
              <P2>
                나) 별도 DB로 옮겨진 개인정보는 법률에 의한 경우를 제외하고는 다른 목적으로 이용되지 않으며 관리자 외
                접근을 엄격하게 통제하고 있습니다.
              </P2>
              <P>2) 파기방법</P>
              <P2>가) 전자적 파일형태로 저장된 개인정보는 재생할 수 없는 안전한 방법을 사용하여 삭제합니다.</P2>
              <P2>나) 종이에 출력된 개인정보는 분쇄기를 통하여 파기합니다.</P2>
            </>
            <>
              <Li>개인정보의 제 3자 제공</Li>
              <P>1) 회사는 원칙적으로 수집 및 이용목적 범위를 넘어 회원의 개인정보를 제 3자에게 제공하지 않습니다.</P>
              <P>
                2) 다만 원활한 의뢰계약을 위해 ‘반려동물 돌봄 서비스’ 예약 시 펫시터에게 회원의 개인정보제공(제 3자
                제공)이 필요합니다. 이 경우 관련법령에서 요구하는 사항을 회원님에게 안내하고 사전 동의를 구합니다.
              </P>
              <P>
                3) 또한 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는
                경우 회원의 개인정보를 제공할 수 있습니다.
              </P>
              <P>4) 돌봄 서비스 구매 시 제 3자 제공에 동의한 경우, 펫시터에게 아래의 개인정보가 제공됩니다.</P>
              <P2>가) 제공 받는 자 : 반려동물 돌봄 서비스 제공 펫시터</P2>
              <P2>나) 제공목적 : 본인 확인</P2>
              <P2>다) 제공정보 : 성명, 휴대폰 번호, 이메일, 주소</P2>
              <P2>라) 보유 및 이용기간 : 서비스 제공 완료 후 6개월</P2>
            </>
            <>
              <Li>개인정보의 취급위탁</Li>
              <P>
                회사는 회원에게 서비스를 제공하는 데에 반드시 필요한 업무 중 일부를 외부 업체에게 위탁하여 수행하고
                있습니다.
              </P>
              <P>
                1) 외부업체에게 업무 위탁 시 계약서 등을 통해서 개인정보보호 관련 법규의 준수, 개인정보에 관한 비밀
                유지, 제 3자 제공에 대한 금지, 사고시의 책임 부담, 위탁기간, 처리 종료 후의 개인정보의 파기 의무 등을
                규정하고, 이를 준수하도록 관리감독하고 있습니다.
              </P>
              <P>2) 회사는 보다 나은 서비스의 제공을 위하여, 아래와 같은 업무를 외부 업체에 위탁하고 있습니다.</P>
              <P2>가) 위탁 업무 : 회원 정보 확인 및 결제 처리를 위한 본인 인증</P2>
              <P3>수탁사 : 다날, NICE평가정보</P3>
              <P2>나) 위탁 업무 : 결제처리(계좌이체, 신용카드) 및 결제도용 방지</P2>
              <P>수탁사 : 아임포트</P>
              <P2>다) 위탁 업무 : 문자 발송</P2>
              <P3>수탁사 : 알리고, 카페24</P3>
              <P2>라) 위탁 업무 : 고객 안내 및 상담 처리 등 고객센터 운영</P2>
              <P3>수탁사 : 더화이트커뮤니케이션</P3>
              <P2>마) 위탁업무 : 안심번호 서비스 제공</P2>
              <P3>수탁사 : ㈜한국케이블텔레콤</P3>
            </>
            <>
              <Li>회원의 권리와 그 행사 방법</Li>
              <P>
                1) 회원은 언제든지 회원의 개인정보를 조회하거나 수정할 수 있으며 회원 탈퇴 절차를 통하여 개인정보 이용에
                대한 동의 등을 철회할 수 있습니다.
              </P>
              <P>
                2) 개인정보 조회/수정을 위해서는 사이트 내의 [계정관리] 내의 [회원탈퇴] 항목에서 확인 가능하며, 회원
                탈퇴(동의 철회)는 [계정관리] 내의 [회원탈퇴] 항목 하단의 “회원 탈퇴”를 통하여 탈퇴하실 수 있습니다. 이
                외에도 회사의 고객센터 및 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하여 열람/수정을 요청하실
                수 있습니다.
              </P>
              <P>
                3) 회원의 개인정보 오류에 대한 정정을 요청한 경우에는 정정을 완료하기 전까지 개인정보를 이용 또는
                제공하지 않습니다. 그리고 회원의 요청에 의해 해지 또는 삭제된 개인정보는 『2. 개인정보의 보유 및
                이용기간』에 명시된 바에 따라 취급하고 그 외의 용도로 열람 또는 이용할 수 없도록 조치하고 있습니다.
              </P>
              <P>
                4) 만 19세 이상인 경우에만 회원가입이 가능하며 개인정보의 수집/이용에 법정대리인의 동의가 필요한 만 19세
                미만 아동의 개인정보는 원칙적으로 수집하지 않습니다. (만 1세 이상 회원가입 정책 2011년 11월 18일부터
                시행)
              </P>
            </>
            <>
              <Li>회원의 의무</Li>
              <P>
                1) 회원은 자신의 개인정보를 보호할 의무가 있으며, 회원 본인의 부주의 등으로 개인정보가 유출되어 발생한
                문제에 대해서는 회사는 일체의 책임을 지지 않습니다.
              </P>
              <P>
                2) 회원은 개인정보를 최신의 상태로 정확하게 입력해야 합니다. 회원의 부정확한 정보입력으로 발생하는
                문제의 책임은 회원 본인에게 있으며, 타인의 개인정보를 도용하여 회원가입 또는 서비스 이용 시 회원자격
                상실과 함께 개인정보에 관한 법률에 의거하여 처벌될 수 있습니다.
              </P>
              <P>
                3) 회원은 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도 가지고
                있습니다. 아이디, 비밀번호를 포함한 회원의 개인정보가 유출되지 않도록 조심하고, 게시물을 포함한 타인의
                개인정보를 훼손하지 않도록 유의해야 합니다.
              </P>
              <P>
                4) 회원은 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보보호법』 등 기타 개인정보에 관한
                법률을 준수하여야 합니다.
              </P>
            </>
            <>
              <Li>개인정보 자동수집 장치(쿠키 등)의 설치, 운영 및 그 거부에 관한 사항</Li>
              <P>
                1) 회사는 회원에게 보다 적절하고 유용한 서비스를 제공하기 위하여 회원의 정보를 수시로 저장하고 불러오는
                ‘쿠키(cookie)’를 사용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 회원의 컴퓨터로
                전송하는 아주 작은 텍스트 파일로서 회원의 컴퓨터 하드디스크에 저장됩니다. 회원은 쿠키의 사용여부에
                대하여 선택할 수 있습니다.
              </P>
              <P>2) 쿠키 설정 거부 방법</P>
              <P2>
                가) 회원이 사용하는 웹 브라우저의 옵션을 설정함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을
                거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 단, 쿠키의 저장을 거부할 경우 로그인이 필요한 일부
                서비스의 이용에 제한이 생길 수 있습니다.
              </P2>
              <P2>나) 쿠키 설치 허용 여부를 지정하는 방법(Internet Explorer의 경우)</P2>
              <P3>a) [도구] 메뉴에서 [인터넷 옵션]을 선택</P3>
              <P3>b) [개인정보]를 클릭</P3>
              <P3>c) [고급]을 클릭</P3>
              <P3>d) 쿠키 허용여부를 선택</P3>
            </>
            <>
              <Li>개인정보의 기술적/관리적 보호 대책</Li>
              <P>회사는 회원의 개인정보를 보호하기 위하여 다음과 같은 보호 대책을 시행하고 있습니다.</P>
              <P>1) 비밀번호의 암호화</P>
              <P>
                회원의 비밀번호는 암호화되어 저장 및 관리되고 있습니다. 비밀번호는 오직 회원 본인만이 알 수 있으며
                개인정보를 확인 및 변경할 경우에도 비밀번호를 알고 있는 본인에 의해서만 가능합니다. 따라서 회원의
                비밀번호가 타인에게 알려지지 않도록 각별히 주의하시기 바랍니다.
              </P>
              <P>2) 해킹 및 컴퓨터 바이러스 등에 대비</P>
              <P>
                회사는 해킹이나 컴퓨터 바이러스에 의하여 회원들의 개인정보가 유출되거나 훼손되는 것을 막기 위하여 필요한
                보안조치를 이용하고 있으며, 더욱 향상된 보안조치를 확보할 수 있도록 가능한 모든 기술적 방법을 구비하기
                위하여 노력하고 있습니다.
              </P>
              <P>3) 개인정보 취급자의 제한 및 교육</P>
              <P>
                회사는 개인정보를 취급하는 직원을 최소한으로 제한하고 있으며, 관련 직원들에 대한 교육을 수시로 실시하여
                본 방침의 이행 및 준수여부를 확인하고 있습니다.
              </P>
            </>
            <>
              <Li>개인정보보호책임자</Li>
              <P>
                회원의 개인정보를 보호하고 개인정보와 관련된 불만 등을 처리하기 위하여 회사는 고객서비스담당 부서 및
                개인정보보호책임자를 두고 있습니다. 회원의 개인정보와 관련된 문의사항은 아래의 고객서비스담당 부서 또는
                개인정보보호책임자에게 연락하여 주시기 바랍니다.
              </P>
              <P>고객서비스 담당 부서</P>
            </>
            <>
              <P>이름 : CS실</P>
              <P>연락처 : 1522-9759</P>
              <P>이메일 : help@dogmate.co.kr</P>
              <P>개인정보보호책임자</P>
              <P2>이름 : 이하영</P2>.<P2>연락처 : 1522-9759</P2>
              <P2>이메일 : help@dogmate.co.kr</P2>
              <P>기타 개인정보침해에 대한 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.</P>
              <P2>1) 개인정보보호위원회</P2>
              <P3>(http://www.pipc.go.kr / 국번 없이 118)</P3>
              <P2>2) 대검찰청 사이버범죄수사단</P2>
              <P3>(http://www.spo.go.kr / 국번 없이 1301)</P3>
              <P2>3) 경찰청 사이버테러대응센터</P2>
              <P3>(http://cyberbureau.police.go.kr / 국번없이 182)</P3>
            </>
            <>
              <Li>개인정보취급방침의 개정과 그 공지</Li>
              <P>현 개인정보취급방침을 개정할 경우 시행 7일 전에 홈페이지 또는 이메일을 통해 사전 공지합니다.</P>
              <P>이 정책은 아래 시행일자부터 시행됩니다.</P>
              <br />
              <P>- 공고 일자 : 2020년 7월 10일</P>
              <P>- 시행 일자 : 2020년 7월 17일</P>
            </>
          </OlDecimal>
        </>
      </div>
    </div>
  );
}

export function P({ children }) {
  const p = css`
    font-size: 14px;
    line-height: 1.64;
    letter-spacing: -0.46px;
    color: ${Color.LIGHT_DARK_GRAY};
  `;

  return <p className={p}>{children}</p>;
}

export function P2({ children }) {
  const p = css`
    font-size: 14px;
    line-height: 1.64;
    letter-spacing: -0.46px;
    color: ${Color.LIGHT_DARK_GRAY};
    margin-left: 14px;
  `;

  return <p className={p}>{children}</p>;
}

export function P3({ children }) {
  const p = css`
    font-size: 14px;
    line-height: 1.64;
    letter-spacing: -0.46px;
    color: ${Color.LIGHT_DARK_GRAY};
    margin-left: 20px;
  `;

  return <p className={p}>{children}</p>;
}

export function H1({ children }) {
  const h1 = css`
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.52px;
    margin: 13px 0;
  `;

  return <div className={h1}>{children}</div>;
}

export function OlDecimal({ children }) {
  const ol = css`
    list-style-type: decimal;
    margin-left: 14px;
  `;

  return <ol className={ol}>{children}</ol>;
}

export function OlLowerAlpha({ children }) {
  const ol = css`
    list-style-type: lower-alpha;
    margin-left: 14px;
  `;

  return <ol className={ol}>{children}</ol>;
}

export function OlLowerCircle({ children }) {
  const circle = css`
    list-style-type: circle;
    margin-left: 28px;
  `;

  return <ol className={circle}>{children}</ol>;
}

export function Li({ children }) {
  const li = css`
    font-size: 14px;
    line-height: 1.64;
    letter-spacing: -0.46px;
    color: ${Color.LIGHT_DARK_GRAY};
  `;

  return <li className={li}>{children}</li>;
}

export function Bold({ children }) {
  const bold = css`
    font-size: 14px;
    font-weight: bold;
    line-height: 1.64;
    letter-spacing: -0.46px;
    color: ${Color.LIGHT_DARK_GRAY};
  `;
  return <p className={bold}>{children}</p>;
}
